import { DocumentPickerState, } from '@voltmoney/schema';
export const args = {
    titleLabel: 'Document Picker',
    ctaLabel: 'Upload',
    state: DocumentPickerState.DEFAULT,
};
export const argTypes = {
    state: {
        control: 'select',
        options: [
            ...Object.values(DocumentPickerState),
        ],
    },
};
